import React, { useCallback, useEffect, useState } from 'react';
import FromFieldDate from "../../atoms/FromFieldDate";
import * as CryptoJS from "crypto-js";
import { getBlockList, getSavedITDepBlockWise, saveITDepBlockWise } from "../../services/it-depreciation.service";

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return day + '-' + month + '-' + year;
    } else {
        return null;
    }
}

function AddOBITDepBlockWise() {
    const [blocks, setBlocks] = useState([]);
    const [earliestPeriodtDate, setEearliestPeriodtDate] = useState('');
    const [closingPeriodDate, setClosingPeriodDate] = useState('');
    const [ErrearliestPeriodtDate, setErrEarliestPeriodtDate] = useState('');
    const [ErrClosingPeriodDate, setErrClosingPeriodDate] = useState('');

    const [isEditMode, setIsEditMode] = useState(false);
    const [success, setSuccess] = useState('');
    const [errMsg, setErrMsg] = useState('');

    const fetchITBlockMaster = useCallback(async () => {
        try {
            const token = sessionStorage.getItem('LoggedInToken');
            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({ authToken: token }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const res = await getBlockList({ token: EncryptData });
            if (res?.data?.data?.length) {
                const initialData = res.data.data.map(block => ({
                    id: block.id,
                    block_name: block.block_name,
                    block_rate: block.block_rate,
                    opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0,
                    total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0,
                    esd_dep: 0, total_depreciation: 0, net_wdv: 0
                }));
                setBlocks(initialData);
            }
        } catch (err) { console.error("Error:", err); }
    }, []);

    const getFilledData = useCallback(async (startDate, endDate) => {
        const formattedStart = new Date(startDate).toISOString().split('T')[0];
        const formattedEnd = new Date(endDate).toISOString().split('T')[0];

        try {
            const token = sessionStorage.getItem('LoggedInToken');
            const payload = { earliest_period: formattedStart, closing_period: formattedEnd };

            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({ param_data: payload, authToken: token }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const res = await getSavedITDepBlockWise({ token: EncryptData });

            if (res?.data?.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                const dbRowsArray = res.data.data;

                setBlocks(prevBlocks => {
                    if (prevBlocks.length === 0) return prevBlocks;

                    return prevBlocks.map(masterBlock => {
                        const savedRow = dbRowsArray.find(r => parseInt(r.block_id) === parseInt(masterBlock.id));

                        if (savedRow) {
                            return {
                                ...masterBlock,
                                opening_wdv: parseFloat(savedRow.opening_wdv) || 0,
                                sale_proceeds: parseFloat(savedRow.sale_proceeds) || 0,
                                add_more_180: parseFloat(savedRow.add_more_180) || 0,
                                add_less_180: parseFloat(savedRow.add_less_180) || 0,
                                total_value: parseFloat(savedRow.total_value) || 0,
                                dep_opening: parseFloat(savedRow.dep_opening) || 0,
                                more_then_6_month: parseFloat(savedRow.more_then_6_month) || 0,
                                less_then_6_month: parseFloat(savedRow.less_then_6_month) || 0,
                                esd_dep: parseFloat(savedRow.esd_dep) || 0,
                                total_depreciation: parseFloat(savedRow.total_depreciation) || 0,
                                net_wdv: parseFloat(savedRow.net_wdv) || 0
                            };
                        }
                        return masterBlock;
                    });
                });

                setIsEditMode(false);
                setSuccess(res.data.message || "Data Loaded");
                setErrMsg("");
            } else {
                fetchITBlockMaster();
                setSuccess("");
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setErrMsg("Something went wrong while fetching data.");
        }
    }, [fetchITBlockMaster]);

    useEffect(() => {
        fetchITBlockMaster();
    }, [fetchITBlockMaster]);

    useEffect(() => {
        if (earliestPeriodtDate && closingPeriodDate) {
            const start = new Date(earliestPeriodtDate);
            const end = new Date(closingPeriodDate);

            if (end <= start) {
                setErrClosingPeriodDate('Closing Period Date must be greater than Earliest Period Date');
            } else {
                setErrClosingPeriodDate('');
                getFilledData(earliestPeriodtDate, closingPeriodDate);
            }
        }
    }, [earliestPeriodtDate, closingPeriodDate, getFilledData]);

    const handleInputChange = (index, field, value) => {
        const updatedBlocks = [...blocks];
        const val = parseFloat(value) || 0;
        updatedBlocks[index][field] = val;

        const b = updatedBlocks[index];
        b.total_value = b.opening_wdv + b.add_more_180 + b.add_less_180 - b.sale_proceeds;
        b.total_depreciation = b.dep_opening + b.more_then_6_month + b.less_then_6_month + b.esd_dep;
        b.net_wdv = b.total_value - b.total_depreciation;

        setBlocks(updatedBlocks);
    };

    const calculateGrandTotal = (fieldName) => {
        return blocks.reduce((sum, block) => sum + (parseFloat(block[fieldName]) || 0), 0).toFixed(2);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let isValid = true;

        if (!earliestPeriodtDate) {
            setErrEarliestPeriodtDate('Earliest Period Date is required');
            isValid = false;
        } else setErrEarliestPeriodtDate('');

        if (!closingPeriodDate) {
            setErrClosingPeriodDate('Closing Period Date is required');
            isValid = false;
        } else setErrClosingPeriodDate('');

        if (isValid) {
            saveITDepBlockWiseData();
        }
    };

    const saveITDepBlockWiseData = () => {
        try {
            const payload = {
                earliest_period: earliestPeriodtDate,
                closing_period: closingPeriodDate,
                blocks_data: blocks.map(block => ({
                    block_id: block.id,
                    opening_wdv: block.opening_wdv,
                    sale_proceeds: block.sale_proceeds,
                    add_more_180: block.add_more_180,
                    add_less_180: block.add_less_180,
                    total_value: block.total_value,
                    dep_opening: block.dep_opening,
                    more_then_6_month: block.more_then_6_month,
                    less_then_6_month: block.less_then_6_month,
                    esd_dep: block.esd_dep,
                    total_depreciation: block.total_depreciation,
                    net_wdv: block.net_wdv
                })),
                created_by: sessionStorage.getItem('LoggedInUserId')
            };

            const encryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: payload,
                    authToken: sessionStorage.getItem('LoggedInToken')
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            saveITDepBlockWise({ token: encryptData })
                .then(res => {
                    if (res?.data?.success) {
                        setSuccess(res.data.message || "Data saved successfully");
                        setIsEditMode(false);
                    } else {
                        setErrMsg(res.data.message || "Save failed");
                    }
                })
                .catch(() => setErrMsg("Server Error"));
        } catch (err) {
            setErrMsg("Encryption Error");
        }
    };

    const resetForm = useCallback(() => {
        setEearliestPeriodtDate('');
        setClosingPeriodDate('');
        setIsEditMode(false);
        setSuccess('');
        setErrMsg('');
        const resetBlocks = blocks.map(b => ({
            ...b,
            opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0,
            total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0,
            esd_dep: 0, total_depreciation: 0, net_wdv: 0
        }));
        setBlocks(resetBlocks);
    }, [blocks]);

    const handleEditClick = () => {
        setIsEditMode(true);
    };

    const handleClosingDateChange = (value) => {
        setClosingPeriodDate(value);
        if (earliestPeriodtDate && value) {
            const start = new Date(earliestPeriodtDate);
            const end = new Date(value);
            if (end <= start) {
                setErrClosingPeriodDate('Closing Period Date must be greater than Earliest Period Date');
            } else {
                setErrClosingPeriodDate('');
            }
        } else {
            setErrClosingPeriodDate('');
        }
    };

    return (
        <div className="container-fluid mt-4">
            <div className="card shadow mb-4">
                <div className="card-header py-3 bg-light">
                    Add OB IT Dep Block Wise
                </div>

                {success && <div className="alert alert-success m-2">{success}</div>}
                {errMsg && <div className="alert alert-danger m-2">{errMsg}</div>}

                <form onSubmit={handleSubmit} className="mt-4">
                    <div className="card-body">
                        <div className="container-fluid mt-4">
                            <div className="row mb-3">
                                <div className="col-6">
                                    <FromFieldDate
                                        label="Earliest Period"
                                        inputValue={earliestPeriodtDate}
                                        setInputValue={setEearliestPeriodtDate}
                                        setErrorMsg={ErrearliestPeriodtDate}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <FromFieldDate
                                        label="Closing Period"
                                        inputValue={closingPeriodDate}
                                        setErrorMsg={ErrClosingPeriodDate}
                                        min={earliestPeriodtDate}
                                        setInputValue={handleClosingDateChange}
                                    />
                                </div>
                            </div>

                            {/* SCROLLER WRAPPER START */}
                            <div className="table-responsive shadow-sm rounded border" style={{ overflowX: 'auto', backgroundColor: '#fff' }}>
                                <table
                                    className="table table-bordered table-sm text-center align-middle"
                                    style={{
                                        fontSize: '11px',
                                        tableLayout: 'fixed',
                                        width: '100%',
                                        minWidth: '1500px' // क्षैतिज स्क्रॉल को ठीक करने के लिए न्यूनतम चौड़ाई
                                    }}
                                >
                                    <thead className="text-center align-middle bg-light">
                                    <tr>
                                        <th rowSpan={2} style={{ width: '220px', position: 'sticky', left: 0, backgroundColor: '#f8f9fa', zIndex: 4 }}>Income Tax Block</th>
                                        <th rowSpan={2} style={{ width: '80px', position: 'sticky', left: '220px', backgroundColor: '#f8f9fa', zIndex: 4 }}>Block Rate</th>
                                        <th rowSpan={2} style={{ width: '140px' }}>Opening WDV<br/><small className="text-muted">({earliestPeriodtDate ? getFormatedDate(earliestPeriodtDate) : 'NA'})</small></th>
                                        <th rowSpan={2} style={{ width: '140px' }}>Sale Proceeds</th>

                                        {/* Additions Section */}
                                        <th colSpan={2} className="table-info">Additions</th>

                                        <th rowSpan={2} style={{ width: '140px' }}>Total Value</th>

                                        {/* Depreciation Section */}
                                        <th colSpan={5} className="table-info">Depreciation</th>

                                        <th rowSpan={2} style={{ width: '140px' }}>Net WDV<br/><small className="text-muted">({closingPeriodDate ? getFormatedDate(closingPeriodDate) : 'NA'})</small></th>
                                    </tr>
                                    <tr style={{ whiteSpace: 'nowrap', backgroundColor: '#34495e', color: '#fff' }}>
                                        {/* Sub-headers for Additions */}
                                        <th style={{ width: '110px' }}>&gt; 180 Days</th>
                                        <th style={{ width: '110px' }}>&lt; 180 Days</th>

                                        {/* Sub-headers for Depreciation */}
                                        <th style={{ width: '110px' }}>Opening</th>
                                        <th style={{ width: '110px' }}>&gt; 6 Months</th>
                                        <th style={{ width: '110px' }}>&lt; 6 Months</th>
                                        <th style={{ width: '110px' }}>ESD Dep.</th>
                                        <th style={{ width: '110px' }}>Total Dep.</th>
                                    </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                    {blocks.map((block, index) => (
                                        <tr key={index} className="text-end">
                                            <td className="text-start fw-bold text-dark"
                                                style={{ position: 'sticky', left: 0, backgroundColor: '#fdfefe', zIndex: 1, borderRight: '1px solid #dee2e6' }}>
                                                {block.block_name}
                                            </td>

                                            <td className="text-center bg-light"
                                                style={{ position: 'sticky', left: '220px', zIndex: 1, borderRight: '2px solid #dee2e6' }}>
                                                {block.block_rate}%
                                            </td>
                                            <td><input
                                                type="number"
                                                className="form-control form-control-sm text-end"
                                                value={block.opening_wdv}
                                                onChange={(e) => handleInputChange(index, 'opening_wdv', e.target.value)}
                                                disabled={!isEditMode}
                                            /></td>
                                            <td><input
                                                type="number"
                                                className="form-control form-control-sm text-end"
                                                value={block.sale_proceeds}
                                                onChange={(e) => handleInputChange(index, 'sale_proceeds', e.target.value)}
                                                disabled={!isEditMode}
                                            /></td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.add_more_180}
                                                       onChange={(e) => handleInputChange(index, 'add_more_180', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.add_less_180}
                                                       onChange={(e) => handleInputChange(index, 'add_less_180', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td className="fw-bold text-primary bg-light">
                                                <input type="number" className="form-control form-control-sm text-end fw-bold text-primary" value={block.total_value} readOnly/>
                                            </td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.dep_opening}
                                                       onChange={(e) => handleInputChange(index, 'dep_opening', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.more_then_6_month}
                                                       onChange={(e) => handleInputChange(index, 'more_then_6_month', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.less_then_6_month}
                                                       onChange={(e) => handleInputChange(index, 'less_then_6_month', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td><input type="number" className="form-control form-control-sm text-end"
                                                       value={block.esd_dep}
                                                       onChange={(e) => handleInputChange(index, 'esd_dep', e.target.value)}
                                                       disabled={!isEditMode}/></td>
                                            <td className="fw-bold text-danger bg-light">
                                                <input type="number" className="form-control form-control-sm text-end fw-bold text-danger" value={block.total_depreciation} readOnly/>
                                            </td>
                                            <td className="fw-bold text-success" style={{ backgroundColor: '#e9f7ef' }}>
                                                <input type="number" className="form-control form-control-sm text-end fw-bold text-success" value={block.net_wdv} readOnly/>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>

                                    <tfoot className="bg-light font-weight-bold text-end border-top-2">
                                    <tr style={{ fontSize: '13px' }}>
                                        <td className="text-center text-uppercase p-2"
                                            style={{ position: 'sticky', fontWeight: 'bold', left: 0, backgroundColor: '#f8f9fa', zIndex: 2 }}>Grand Total:</td>
                                        <td style={{ position: 'sticky', left: '220px', backgroundColor: '#f8f9fa', zIndex: 2 }} className="text-center">-</td>
                                        <td className="text-primary">{calculateGrandTotal('opening_wdv')}</td>
                                        <td>{calculateGrandTotal('sale_proceeds')}</td>
                                        <td>{calculateGrandTotal('add_more_180')}</td>
                                        <td>{calculateGrandTotal('add_less_180')}</td>
                                        <td className="text-primary bg-white fw-bold">{calculateGrandTotal('total_value')}</td>
                                        <td>{calculateGrandTotal('dep_opening')}</td>
                                        <td>{calculateGrandTotal('more_then_6_month')}</td>
                                        <td>{calculateGrandTotal('less_then_6_month')}</td>
                                        <td>{calculateGrandTotal('esd_dep')}</td>
                                        <td className="text-danger bg-white fw-bold">{calculateGrandTotal('total_depreciation')}</td>
                                        <td className="text-success bg-white fw-bold">{calculateGrandTotal('net_wdv')}</td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                            {/* SCROLLER WRAPPER END */}

                            {/* Action Buttons */}
                            <div className="d-flex justify-content-center mt-3">
                                <button
                                    className="btn btn-primary btn-sm mx-2"
                                    type="submit"
                                    disabled={!isEditMode && success !== ''}
                                >
                                    {isEditMode ? "Update" : "Save"}
                                </button>

                                <button
                                    className="btn btn-warning btn-sm mx-2"
                                    type="button"
                                    onClick={resetForm}
                                >
                                    Reset
                                </button>

                                <button
                                    className="btn btn-info btn-sm mx-2 text-white"
                                    type="button"
                                    onClick={handleEditClick}
                                    disabled={isEditMode}
                                >
                                    Edit
                                </button>

                                <button className="btn btn-danger btn-sm mx-2" type="button"
                                        onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddOBITDepBlockWise;